import React, { useState, useEffect, useCallback } from "react";

import { Row, Col, Button, Spinner, Modal } from "react-bootstrap";
import { TextField } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { Checkbox } from '@mui/material';
import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import _ from "lodash";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SwalMessage from "../../_Components/SwalMessage";
// import { DropzoneArea } from "material-ui-dropzone";
import ApiKishPortInfo from "../../../../core/api/api.kishPortInfo";
import ApiFilesService from "../../../../core/api/Api.filesService";
import { useLocation } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
export const CreateEditKishPortInfo = ({ showModalNewContent, setShowModalNewContent, selectedContent }) => {
    let location = useLocation();



    //const { register, handleSubmit, control, formState: { errors }, getValues, setValue } = useForm({defaultValues: { id: 0 }});
    const { register, handleSubmit, control, formState: { errors, isSubmitting }, reset, getValues, setValue } =
        useForm({
            defaultValues: {
                id: selectedContent
                , access: 3
            }
        });

    const [groups, setGroups] = useState([]);
    const [allAmusementPlaceList, setAllAmusementPlaceList] = useState([]);
    const [allAmusementCityList, setAllAmusementCityList] = useState([]);
    const [refreshUseEffect, setrefreshUseEffect] = useState(false);
    const [showImage, setshowImage] = useState("");
    const [files, setFiles] = useState([]);
    const [fileGet, setFileGet] = useState([]);
    const onDrop = useCallback(acceptedFiles => {
        console.log(acceptedFiles);
      }, []);
    
      const { getRootProps, getInputProps } = useDropzone({ 
        onDrop,
        accept: 'image/jpeg, image/png, image/gif, image/jpg, application/pdf',
        maxSize: 5000000
      });
    useEffect(() => {
        (async () => {
            try {


                if (!_.isEmpty(selectedContent) && selectedContent != 0) {

                    const kishportInfoResult = ApiKishPortInfo.get(selectedContent).then((item) => {
                        console.log("response", item)
                        setValue("message", item.message)
                        setValue("isEnabled", item.isEnabled)
                        if (item?.filess) {
                            setFileGet([]);
                            let tt = item?.filess.map((item) => {
                                ApiFilesService.getFile({ id: selectedContent, fileId: item.id, access: 3 }).then(response => {
                                    let objectURL = URL.createObjectURL(new Blob([response]));
                                    setFileGet(oldFileGet => [...oldFileGet, objectURL])
                                })
                            })
                        }

                    })


                }
                // دریافت لیست مکانهای تفریح
                //const amusementPlaces = await ApiAmusementPlace.getAll({ PageNumber: 1, PageSize: 400 });
                // console.log("response", amusementPlaces);
                //setAllAmusementPlaceList(amusementPlaces.data)


                //setSrc();
                setrefreshUseEffect(false);
                setFiles([]);
            } catch (error) {
                console.log("error :>> ", error);
            } finally {
            }
        })();
        return () => { };
    }, [refreshUseEffect]);
    let removeFile = (item) => {

        files.map((item) => {
            files.splice(item, 1);
            setFiles(...files);

        })
    }
    const onSubmit =
        async (data) => {
            console.log("onSubmit2 data=", data);
            try {
                const formData = new FormData();
                for (const [key, value] of Object.entries(data)) {
                    if (key != "attachments") {
                        !_.isUndefined(value) && formData.append(key, value)
                    }
                }

                const kishPortInforesponce = ApiKishPortInfo.addOrEditKishPortInfo(data).then((item) => {
                    if (item?.data != 0) {
                        console.log("item item=", item);

                        if (!_.isEmpty(data.attachments)) {
                            let fileInfoType = [];
                            data.attachments.forEach(element => {
                                formData.append(
                                    "attachments",
                                    element

                                );
                                fileInfoType.push({ path: element.path, name: element.name, type: element.type });

                            });
                            let saveInfoFile = {
                                kishPortInfoId: item?.data,
                                files_type: 6,
                                fileInfoTypeC: fileInfoType,

                            }
                            const kishPortInforesponce = ApiFilesService.saveFileInfo(saveInfoFile).then((responceSaveFile) => {
                                if (responceSaveFile?.data == 1) {

                                    let fileInformation = JSON.parse(responceSaveFile.message);


                                    formData.delete("agentId");
                                    formData.delete("message");
                                    formData.delete("isEnabled");
                                    formData.delete("files_Type");
                                    fileInformation.forEach((element, index) => {
                                        formData.append(
                                            "fileInfo[" + index + "].Id", element.Id

                                        );
                                        formData.append(
                                            "fileInfo[" + index + "].OrginalName", element.OrginalName

                                        );
                                    });
                                    console.log("kishPortInforesponce: ", formData);

                                    const response4 = ApiFilesService.uploadFiles(formData).then((rest2) => {
                                        SwalMessage({ title: rest2.message, iSsuccess: rest2.data, timer: 10000 });
                                        // setrefreshUseEffect(true)
                                    });

                                    setValue("attachments", [])
                                    setrefreshUseEffect(true)
                                    removeFile();
                                    // history.goBack();
                                } else {
                                    SwalMessage({ title: responceSaveFile.message, iSsuccess: responceSaveFile.data, timer: 10000 });
                                }

                            });


                        }
                        else {
                            SwalMessage({ title: item.message, iSsuccess: item.data, timer: 10000 });
                        }



                    } else {
                        SwalMessage({ title: item.message, iSsuccess: item.data, timer: 10000 });
                    }


                });



                // if (data.id <= 0)
                // response = await ApiAmusementService.create(data);
                // else
                // response = await ApiAmusementService.update(data.id, data);
                // برای رفرش کردن لیست در حالتی که فرم مدال استفاده شود
                // if (response.succeeded === true)
                //     (document.getElementById('submitButton')).click();
                // console.log("onSubmit2 response=", response);
                //SwalMessage({ title: response.message, iSsuccess: response.succeeded });
            } catch (error) {
                console.log("error=", error);
            }
        }

    const selectStyles = {

        menu: base => ({
            ...base,
            zIndex: 10000
        })
    }

    const viewImageFile = (urlImage) => event => {

        setshowImage(urlImage);


    }
    let handleClose = (e) => {
        // !_.isEmpty(e) && e.stopPropagation();
        // history.goBack();
        // setshowImage("");
        setShowModalNewContent(false);

    };


    return (
        <div>
            <Modal centered size='lg' show={showModalNewContent} onHide={handleClose}>
                <Modal.Header closeButton>
                    {/* <Modal.Title>ایجاد گروه تخفیف </Modal.Title> */}
                </Modal.Header>
                <Modal.Body >
                </Modal.Body>
                <img src={showImage} width="80%" height="80%"  ></img>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        <CloseIcon />  بستن
                    </Button>
                </Modal.Footer>

            </Modal>
            <div className={`card card-custom`}>
                {/* Start Box Header */}
                <div className="card-header border-0 pb-3 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            ایجاد محتوای جدید صفحه بندرگاه کیش
                        </span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">
                            برای افزودن محتوای جدید، موارد زیر را تکمیل نمایید
                        </span>
                    </h3>
                </div>
                {/*Start body */}
                <form key={2} id="form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="card-body pt-3 pb-0 border-top">

                        <Row>
                            {/* <Col xs="12" lg="12">    <h6 className="my-5">متن نمایش</h6>
                                <Controller
                                    name="message"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={value || ""}
                                            onReady={(editor) => {

                                            }}
                                            onChange={(event, editor) => {
                                                value = editor.getData();
                                                //setBody(data);                                           
                                                onChange = event;
                                                setValue("message", value);
                                                //  console.log("OOOOOO", { event, editor});
                                            }}
                                            onBlur={(event, editor) => {
                                                // console.log("Blur.", editor);
                                            }}
                                            onFocus={(event, editor) => {
                                                // console.log("Focus.", editor);
                                            }}
                                            // config={{
                                            //     ckfinder:{uploadUrl:((item)=> showfile(item))}
                                            //  }}
                                          // UploadAdapter={FileRepository}
                                        />




                                    )}
                                /></Col> */}
                            <Col xs="12" sm="12" lg="12">
                                {/* <h6 className="my-5">متن نمایش</h6> */}
                                <Controller
                                    name="message"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <TextField
                                            label="متن نمایش به کاربران"
                                            type="text"
                                            rows={10}
                                            multiline
                                            variant="outlined"
                                            margin="normal"
                                            className=""
                                            // placeholder="توضیحات"
                                            value={value || ""}
                                            onChange={onChange}
                                        />
                                    )}
                                />
                            </Col>

                        </Row>
                        <Row>
                            <Col xs='12' sm='7' lg='6'>


                                <Col xs='12'>
                                    <FormControlLabel
                                        control={
                                            <Controller
                                                control={control}
                                                name={"isEnabled"}
                                                render={({ field: { onChange, onBlur, value, name, ref },
                                                    fieldState: { invalid, isTouched, isDirty, error },
                                                }) => (
                                                    <Checkbox
                                                        color="primary"
                                                        onBlur={onBlur}
                                                        onChange={onChange}
                                                        checked={value || false}
                                                        inputRef={ref}
                                                    />
                                                )}
                                            />
                                        }
                                        label="وضعیت نمایش"
                                    />
                                </Col>

                            </Col>

                        </Row>
                        <Row>
                            <Col xs='12' sm='7' lg='12'>
                                <h6 className="my-5">عکس های آپلود شده:</h6>

                                {
                                    fileGet?.length > 0 ?
                                        <div className='d-flex  mt-1 ' style={{ overflowX: "scroll" }}>
                                            {fileGet.map((item) => (

                                                <img src={item} width="20%" height="20%" onClick={viewImageFile(item)} style={{ cursor: 'pointer' }} ></img>

                                            )

                                            )}
                                        </div>
                                        :
                                        <p>تصویری پیدا نشد .</p>
                                }

                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col xs='12' sm='7' lg='12' className="mt-3 mt-lg-0">
                               {/* <Controller*/}
                               {/*     name="attachments"*/}
                               {/*     control={control}*/}
                               {/*     defaultValue=""*/}
                               {/*     render={({ field }) => (*/}
                               {/*         <>*/}
                                      

                               {/*             { <DropzoneArea  */}
                               {/*acceptedFiles={["image/jpeg","image/png","image/jpg"]}*/}
                               {/*getFileRemovedMessage={(fileName) => `${fileName} از لیست ارسالی حذف گردید.`}*/}
                               {/*getFileLimitExceedMessage={(filesLimit) => `امکان ارسال بیشتر 3 فایل در هر آپلود وجود ندارد.`} //  ${filesLimit}*/}
                               {/*getFileAddedMessage={(fileName) => `فایل اضافه شد!`}*/}
                               {/*getDropRejectMessage={(rejectedFile) => `فقط فایل های عکس را می توانید آپلود نمایید`}*/}
                               {/*fileObjects={files}  onChange={e=> {field.onChange(e)}} */}
                               {/* dropzoneText="انتخاب فایل جدید"*/}
                               
                                
                               {/* /> }*/}

                               {/*         </>*/}
                               {/*     )}*/}
                               {/* />*/}

                                <Controller
                                    name="attachments"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <Box
                                            {...getRootProps()}
                                            sx={{
                                                border: '2px dashed #cccccc',
                                                padding: '20px',
                                                textAlign: 'center',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <input {...getInputProps()} onChange={e => field.onChange(e)} />
                                            <Typography variant="body1">انتخاب فایل</Typography>
                                            <Box>
                                                {files && files.map((file, index) => (
                                                    <Typography key={index} variant="body2">
                                                        {file.name}
                                                    </Typography>
                                                ))}
                                            </Box>
                                        </Box>
                                    )}
                                />
                            </Col>
                        </Row>
                        <hr />
                    </div>
                    <div className="float-right mx-5">
                        <Button variant="success" type="submit" disabled={isSubmitting}>
                            {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                            <SaveIcon />  ذخیره
                        </Button>
                        <Link className='btn btn-danger ml-3' to='/kishPortInfo'>
                            <CloseIcon />  بازگشت
                        </Link>
                    </div>
                </form>

            </div>
        </div>
    );
}
